import { useQuery } from '@tanstack/react-query';
import { getProjects } from '../services/api/projects';

/**
 * Phase 23 NAV-01 / NAV-03: fetch the current internal user's membered projects
 * (PM OR ProjectAssignment) plus ghost ancestors. Backed by GET /api/projects?memberOf=true.
 */
export function useMyProjects() {
  return useQuery({
    queryKey: ['my-projects'],
    queryFn: () => getProjects({ memberOf: true }),
  });
}
